import React, { createContext, useState } from "react";

import { GeosuggestContextProps } from "./types";

/**
 * Geosuggest must be manually wrapped in Context to enable external programmatic control of the geosuggest input
 */
export const GeosuggestContext = createContext<GeosuggestContextProps>({
  value: "",
  setValue: () => {
    return;
  },
});

export const GeosuggestProvider: React.FC = ({ children }) => {
  const [value, setValue] = useState<string>("");

  return (
    <GeosuggestContext.Provider
      value={{
        value,
        setValue,
      }}
    >
      {children}
    </GeosuggestContext.Provider>
  );
};
